package org.zq.linkgame.sound

/**
 * Web implementation of SoundManager
 * Web audio can be implemented using JavaScript interop if needed
 */
actual object SoundManager {
    actual fun init() {
        // Web audio initialization - can be implemented with JS interop
    }
    
    actual fun playMatchSound() {
        // Web audio playback - can be implemented with JS interop
    }
}
